<template>
  <div>
    <h1 class="common__main-title">Student detail</h1>
    <div class="common__sub-title">
      <span>Details</span>
    </div>
    <div class="common__main-contener">
      <div class="common__main-content">
        <div>
          <div>
            <p>Student number</p>
            <div class="detail-item">{{ student && student.studentNumber }}</div>
          </div>
          <div>
            <p>Old Student number</p>
            <div class="detail-item">{{ student && student.oldStudentNumber }}</div>
          </div>
          <div>
            <p>Student Name</p>
            <div class="detail-item">{{ student && student.nameJp }}</div>
          </div>
          <div>
            <p>Student Name (Alphabet)</p>
            <div class="detail-item">{{ student && student.name }}</div>
          </div>
          <div>
            <p>Nickname</p>
            <div class="detail-item">{{ student && student.nickname }}</div>
          </div>
          <div>
            <p>Student status</p>
            <div class="detail-item">{{ student && student.studentStatus | status }}</div>
          </div>
          <b-row>
            <b-col>
              <p>Email1</p>
              <div class="detail-item">{{ student && student.email1 }}</div>
            </b-col>
            <b-col>
              <p>Email2</p>
              <div class="detail-item">{{ student && student.email2 }}</div>
            </b-col>
          </b-row>
          <b-row class="mb-5">
            <b-col>
              <p>Contact1</p>
              <div class="detail-item">{{ student && student.phone1 }}</div>
            </b-col>
            <b-col>
              <p>Contact2</p>
              <div class="detail-item">{{ student && student.phone2 }}</div>
            </b-col>
          </b-row>
        </div>
        <StudentTab v-if="student" :student="student" />
      </div>
      <div class="d-flex justify-content-between">
          <b-button pill variant="secondary" :to="{name:'Students'}" >
            Back
          </b-button>
          <b-button
            v-if="hasAuth(['admin'])"
            pill
            variant="primary"
            :to="{ name:'EditStudent', id: $route.params.id }"
          >
            Edit
          </b-button>
        </div>
    </div>
    <Loading :isLoading="isLoading" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import _ from 'lodash'
import StudentTab from '@/components/parts/students/StudentTab.vue'
import Loading from '@/components/parts/modal/Loading.vue'
import { Student, StudentStatus, studentStatusCode } from '@/store/students/types'
import { RootState } from '@/store/types'

export default Vue.extend({
  components: {
    StudentTab,
    Loading,
  },
  created() {
    this.fetch()
  },
  data(): {
    isLoading: boolean,
    } {
    return {
      isLoading: false,
    }
  },
  computed: {
    student(): Student {
      return this.$store.getters.findStudentById(this.$route.params.id)
    },
  },
  methods: {
    fetch() {
      if (this.isLoading) {
        return
      }
      this.isLoading = true

      this.$store.dispatch('getStudent', {
        studentId: this.$route.params.id,
      }).finally(() => {
        this.isLoading = false
      })
    },
    hasAuth(acceptRoles: string[]): boolean {
      const auth = (this.$store.state as RootState).auth.profile?.authority
      return _.indexOf(acceptRoles, auth) !== -1
    },
  },
  filters: {
    status: (s: studentStatusCode): string => StudentStatus[s],
  },
});
</script>

<style scoped>
.content-wrapper {
  background: #D8D8D8;
  padding: 20px 50px;
}

.main-content {
  background: #fff;
  padding: 30px 60px;
  border-radius: 20px;
  margin-bottom:20px;
}

.detail-item {
  display: block;
  margin-bottom: 1.5rem;
  margin-left: 10px;
  color: #214D91;
  font-weight: bold;
  font-size: 14px;
  letter-spacing: 0.5px;
}

#contents {
  padding: 40px;
  height:800px;
  margin-bottom:20px;
  background: #fff;
  border-radius: 20px ;
}
</style>
